import React from 'react'
import PropTypes from 'prop-types'

import { useSelector } from 'react-redux'

import useSessionStatusModal from '../../hooks/useSessionStatusModal'
import { CloningStatusEnum } from '../../constants'
import { selectEditURLForSession } from '../../reducers/clone_leagues_sessions'

const SessionName = ({session}) => {
  const editSessionURL = useSelector(selectEditURLForSession(session.id))
  const { openModal } = useSessionStatusModal()

  const onClick = (event) => {
    event.stopPropagation()

    if (session.status === CloningStatusEnum.DRAFT) {
      window.location.href = editSessionURL
    } else {
      openModal(session.id)
    }
  }

  return (<span
    onClick={(event) => onClick(event)}
    className={'cls-session-name'}>
    {session.name}
  </span>)

}

SessionName.propTypes = {
  session: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(CloningStatusEnum)).isRequired,
  }),
}

export default SessionName
